export default __webpack_public_path__ + "static/media/knife.99dfae3a.jpg";